import { localStorageManager } from "@/services/localStorage";
import { useState } from "react";
import { SortingState, PaginationState } from "@tanstack/react-table";

export interface TableState {
  sorting?: SortingState;
  filtering?: { [key: string]: string | undefined };
  pagination?: PaginationState;
}

export const useTableState = (key: string, defaultState: TableState = {}) => {
  const [, refresh] = useState({});

  let savedState = defaultState;
  try {
    const stored = localStorageManager.getItem(key);
    if (stored) {
      savedState = JSON.parse(stored) as TableState;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    // noop - use default state if parsing fails
  }

  const saveTableState = (state: TableState) => {
    localStorageManager.setItem(key, JSON.stringify(state));
    refresh({});
  };

  const resetTableState = () => {
    localStorageManager.setItem(key, "");
    refresh({});
  };

  return {
    savedState,
    saveTableState,
    resetTableState,
  };
};
